import { pick } from 'lodash';

export const name =
  'Падсвятліць няправільныя словы. Калі гук не адпавядае тэксту, націсніце на няправільнае слова.';
export const nameShort = 'Падсвятліць няправільныя словы';
export const bgInTable = '#46c5ec';

export const fields = [
  {
    name: 'correctAnswers',
    default: [],
    label: 'Правільныя адказы',
    component: 'ListNewValues',
  },
  {
    name: 'afterTaskExplanation',
    default: '',
    label: 'Тлумачэнне задання',
    component: 'Textarea',
  },
  {
    name: 'textContent',
    default: '',
    label: 'Змест задання',
    component: 'Input',
  },
  {
    name: 'audio',
    default: '',
    label: 'Аўдыёзапісы',
    component: 'AudioInput',
  },
];

export const dataToSend = form => {
  return {
    additionalData: {
      afterTaskExplanation: form.afterTaskExplanation,
      textContent: form.textContent,
      audio: form.audio,
    },
    type: 'highlight_incorrect',
    name: form.name,
    tip: form.tip,
    status: form.status,
    correctAnswers: form.correctAnswers,
  };
};

export const parseData = data => {
  const dataFast = pick(data, ['name', 'status', 'correctAnswers']);
  const { afterTaskExplanation, textContent, audio } = data.additionalData;
  return {
    ...dataFast,
    afterTaskExplanation,
    textContent,
    audio,
  };
};
